/** UK English locale for dates across Pulse (DD/MM/YYYY). */
export const UK_LOCALE = "en-GB";

function toValidDate(value) {
  if (value == null || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

/** Format a date as DD/MM/YYYY (en-GB). */
export function formatUkDate(value) {
  const date = toValidDate(value);
  return date ? date.toLocaleDateString(UK_LOCALE) : "";
}

/** Format a date-time with en-GB locale. */
export function formatUkDateTime(value) {
  const date = toValidDate(value);
  return date ? date.toLocaleString(UK_LOCALE) : "";
}
